import { Badge, Link, Tooltip, TooltipContent } from '@customerio/pluma-components/react';
import { RESTRICTED_ATTRIBUTES } from '../utils/attribute-keys';
import { isAttributeEnabledIdentifier, type IdentifiersConfig } from '../utils/identifiers';

type AttributeTypeLabelProps = {
  attribute: string;
  identifiers: IdentifiersConfig | null | undefined;
};

/**
 * The "Reserved" badge next to an attribute name the system gives special
 * meaning to. An enabled identifier is labelled by its own table, so it gets
 * no badge; an ordinary attribute renders nothing.
 */
export function AttributeTypeLabel({ attribute, identifiers }: AttributeTypeLabelProps) {
  if (isAttributeEnabledIdentifier(attribute, identifiers) || !RESTRICTED_ATTRIBUTES.includes(attribute)) {
    return null;
  }

  return (
    <Tooltip isCustom>
      {(context) => (
        <>
          <Badge
            color="grey"
            cursor="help"
            ref={context.reference.setReference}
            {...context.reference.getReferenceProps()}
            data-test="attribute-type-label"
          >
            Reserved
          </Badge>
          <TooltipContent>
            Some attribute names are reserved for special purposes in our system.
            <br />
            <Link
              href="https://docs.customer.io/journeys/attributes/#reserved-attributes"
              color="inherit"
              isUnderlined
              isExternal
            >
              Learn more about reserved attributes
            </Link>
          </TooltipContent>
        </>
      )}
    </Tooltip>
  );
}
